/**
 * Utility functions for managing signed URL cache cookies
 */

/**
 * Generate the cookie key for a signed URL cache entry
 */
export const getSignedUrlCookieKey = (fileKey: string, bucket: string) => {
  return `signed_url_${bucket}_${fileKey}`;
};

/**
 * Clear a specific signed URL from the cache
 */
export const clearSignedUrlCache = (fileKey: string, bucket: 'gym-logos' | 'gym-documents') => {
  try {
    const cookieKey = getSignedUrlCookieKey(fileKey, bucket);
    document.cookie = `${cookieKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    console.log('🗑️ Cleared signed URL cache for:', { fileKey, bucket });
  } catch (err) {
    console.warn('Error clearing signed URL cache:', err);
  }
};

/**
 * Clear all signed URL caches for a specific bucket
 */
export const clearAllSignedUrlCacheForBucket = (bucket: 'gym-logos' | 'gym-documents') => {
  try {
    const cookiePrefix = `signed_url_${bucket}_`;
    
    // Get all cookies and find ones that match our pattern
    const cookies = document.cookie.split(';');
    
    cookies.forEach(cookie => {
      const cookieName = cookie.split('=')[0].trim();
      if (cookieName.startsWith(cookiePrefix)) {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        console.log('🗑️ Cleared signed URL cache for cookie:', cookieName);
      }
    });
    
    console.log('🧹 Cleared all signed URL caches for bucket:', bucket);
  } catch (err) {
    console.warn('Error clearing signed URL caches for bucket:', err);
  }
};

/**
 * Extract file key from a full URL (removes any query parameters and path prefixes)
 */
export const extractFileKeyFromUrl = (url: string): string | null => {
  try {
    // Handle both full URLs and simple file keys
    if (!url.includes('/')) {
      return url; // Already a file key
    }
    
    // Extract the file name from the URL path
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split('/');
    return pathSegments[pathSegments.length - 1] || null;
  } catch (err) {
    console.warn('Error extracting file key from URL:', err);
    return null;
  }
};
